import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-email-notification-toggle',
    templateUrl: './email-notification-toggle.component.html',
    styleUrls: ['./email-notification-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmailNotificationToggleComponent {
  @Input() value: boolean;
  @Input() label: string;
  @Input() description: string;
  @Output() toggle: EventEmitter<any> = new EventEmitter();
}
